import Link from "next/link";
import { useState, useEffect } from "react";
import { Ads } from "../../ads/Ads";
import ContestWidget from "./ContestWidget";
import CandidateFeed from "./CandidateFeed";
import YoutubeCarousel from "../../YoutubeCarousel";
import styles from "../../../styles/candidate/parts/CandidateDetails.module.scss";

const cfUrl = process.env.API_CF_URL;
const CandidateDetails = ({ url, data, contestName, candidates }) => {
  const [rssYoutubeFeed, setRssYoutubeFeed] = useState([]);
  let candidateFullname = data
    ? ` ${data.first_name} ${data.last_name} ${data.suffix || ""}`
    : "";

  let playlistId = data?.video_playlist?.split("?")[1].split("=")[1];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let isMounted = true;

    const getRss = async () => {
      const responseYT = await fetch(`${cfUrl}/getRSS`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: "yt",
            playlistId
          }
        })
      });
      const { result: youtubeFeeds } = await responseYT.json();
      setRssYoutubeFeed(youtubeFeeds);
    };

    if (isMounted) {
      getRss();
    }

    return () => {
      isMounted = false;
    };
  }, [playlistId]);

  return (
    <div className={styles.candidateDetailsWrapper}>
      <div className={styles.detailsGrid}>
        <div className={styles.biography}>
          <p
            className={styles.candidateDesc}
            dangerouslySetInnerHTML={{
              __html: data?.bio || data?.gpt3_bio || "",
            }}
          />
          {data?.gpt3_bio && (
            <p className={styles.bioDisclaimer}>
              This profile was generated with the help of OpenAI GPT-3 and
              reviewed by Rappler Research for accuracy.
            </p>
          )}
          {data?.candidacy_set[0].contest.scope === "NATIONAL" && (
            <p className={styles.knowMore}>
              To know more about what people want to know about
              <span>{` ${candidateFullname.trim()}`}</span>, visit :
              <Link href={`https://www.rappler.com/people/${data.wp_slug}`}>
                <a target="_blank" rel="noreferrer">
                  Main Profile of {` ${candidateFullname}`}
                </a>
              </Link>
            </p>
          )}
        </div>
        {rssYoutubeFeed && rssYoutubeFeed.length > 0 && (
          <YoutubeCarousel rssYoutubeFeed={rssYoutubeFeed} />
        )}
        <Ads
          deviceType="mobile"
          id="ad-candidate-middle1-mobile"
          adType="middle1"
          pageType="elec_profile_page"
          contestName={contestName}
        />
        {/* <CandidateFeed
          topicUrl={data.topic_page}
          fullName={candidateFullname.trim()}
        /> */}
      </div>
      <div className={styles.detailsGrid}>
        <ContestWidget
          url={url}
          data={data}
          contestName={contestName}
          candidates={candidates}
        />
        <Ads
          deviceType="desktop"
          id="ad-candidate-middle1-desktop"
          adType="middle1"
          pageType="elec_profile_page"
          contestName={contestName}
        />
      </div>
    </div>
  );
};

export default CandidateDetails;
